import {
  Box,
  Button,
  ButtonGroup,
  CssBaseline,
  Stack,
  ThemeProvider,
  Toolbar,
  createTheme,
  useMediaQuery,
} from "@mui/material";
import { blue } from "@mui/material/colors";
import React, { useEffect, useMemo, useState } from "react";
import { Outlet } from "react-router-dom";
import { MeApi } from "./api/MeApi";
import MessagingApi from "./api/MessagingApi";
import {
  DarkModeTwoTone,
  LightModeTwoTone,
  LogoutTwoTone,
} from "@mui/icons-material";

function App() {
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)"),
    lastTheme =
      localStorage.getItem("gameNight.theme") ||
      (prefersDarkMode ? "dark" : "light"),
    [themeMode, setThemeMode] = useState(lastTheme),
    handleThemeChange = (mode) => {
      localStorage.setItem("gameNight.theme", mode);
      setThemeMode(mode);
    };

  useEffect(() => {
    if (themeMode !== lastTheme) {
      setThemeMode(lastTheme);
    }
  }, [lastTheme, themeMode, setThemeMode]);

  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: themeMode,
          ...(themeMode === "dark"
            ? {
                primary: {
                  main: blue["A700"],
                },
              }
            : {
                primary: {
                  main: blue[700],
                },
              }),
        },
      }),
    [themeMode]
  );

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <MessagingApi />
      <MeApi />
      <Stack sx={{ height: 1, p: 2, spacing: 2, width: 1 }}>
        <Toolbar>
          <Stack direction="row" spacing={2} sx={{ width: 1 }}>
            <Box sx={{ flexGrow: 1 }} />
            <ButtonGroup>
              <Button
                onClick={() => {
                  handleThemeChange("light");
                }}
                startIcon={<LightModeTwoTone />}
                variant={themeMode === "light" ? "contained" : "outlined"}
              >
                Light Mode
              </Button>
              <Button
                onClick={() => {
                  handleThemeChange("dark");
                }}
                startIcon={<DarkModeTwoTone />}
                variant={themeMode === "dark" ? "contained" : "outlined"}
              >
                Dark Mode
              </Button>
            </ButtonGroup>
            <Button
              color="inherit"
              href="/logout"
              startIcon={<LogoutTwoTone />}
            >
              Sign Out
            </Button>
          </Stack>
        </Toolbar>
        <Outlet />
      </Stack>
    </ThemeProvider>
  );
}

export default App;
